import {
  PostData,
} from '../@types/postData'

export const getPostData = async (url: string): Promise<PostData> => {
  const res = await fetch(url)
  if (!res.ok) {
    throw new Error('Network response was not ok')
  }
  return res.json()
}